/**
 * @desc: 渠道查询
 * @created: 2020/5/29
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T4/channelQuery'
import { getCompany } from '@/api/selects'

export default {
  namespaced: true,
  actions: {
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    saveCreatedChannel(ctx, payload) {
      return Models.saveCreatedChannel(payload)
    },

    getCompanyDetails(ctx, payload) {
      return Models.getCompanyDetails(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    getWorkArea(ctx, payload) {
      return Models.getWorkArea(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    getWorkMenu(ctx, payload) {
      return Models.getWorkMenu(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    updateChannelData(ctx, payload) {
      return Models.updateChannelData(payload)
    },

    getCompany(ctx, payload) {
      return Models.getCompany(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    checkChannelBind(ctx, payload) {
      return Models.checkChannelBind(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },
  }
}
